import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem,
Grid, Divider, Table, TableBody, TableCell,TableHead, TableRow, TablePagination } from '@material-ui/core';
import { } from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Line} from 'react-chartjs-2';
import Select from 'react-select';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';

const styles = theme => ({
    placeholder: {
        display: 'block'
    },
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
       
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
    },
    button: {
        margin: theme.spacing.unit,
      },
    table : {
        minWidth: 700
    },
    grid: {
        overflowX: 'auto'
    }
})

let id = 0;

class adminDash extends Component{
    constructor(props){
        super(props)
        this.state = {
            viewLevel: '',
            viewSubject: '', 
            viewYear: '',
            viewAbility: '', 
            levelsToSearch: [],
            subjectsToSearch: [],
            yearsToSearch: [],
            abilitiesToSearch: ['Beginner', 'Intermediate', 'Advanced'],
            loading: true,
            graphData: [],
            page: 0,
            rowsPerPage: 5,
            searchTerm: '',
            testDataArr : [],
            cells: [],
            tableData: []
        }
    }

    async componentDidMount(){
        var levelsToSearch = []
        var subjectsToSearch = []
        var yearsToSearch = []
        const ref = await db.collection('Level').get()
        ref.forEach( async level => {
            levelsToSearch.push(level.id)
            var subjArr = []
            var holdingArr = []
            const subjRef = await db.collection('Level').doc(level.id).collection('Subjects').get()
            subjRef.forEach(async subject => {
                subjArr.push(subject.id)
                var yearArr = []
                const yearRef = await db.collection('Level').doc(level.id).collection('Subjects').doc(subject.id).collection('Years').get()
                yearRef.forEach(async year => {
                    yearArr.push(year.id)
                })
                holdingArr.push(yearArr)
            })
            yearsToSearch.push(holdingArr)
            subjectsToSearch.push(subjArr)
        })
        console.log(levelsToSearch, subjectsToSearch, yearsToSearch)
        this.setState({
            ...this.state,
            levelsToSearch: levelsToSearch,
            subjectsToSearch: subjectsToSearch,
            yearsToSearch: yearsToSearch,
        })
    }

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: event.target.value,
            yearError: false,
            subjectError: false, 
            levelError: false,
            abilityError: false
        })
    }

    contentFetch = async (level, subject, year, ability) => {
        if (this.allDefined(level, subject, year, ability)){
            try {
                console.log(level, subject, year, ability)
                //FLESH AND BONES
                var theseTasks = []
                const ref = await db.collection('AssignedTasks').where('Level', '==', level).where('Subject', '==', subject).where('Year', '==', year).where('Ability', '==', ability).get()
                ref.forEach(doc => {
                    var obj = {id: doc.id, data: doc.data()}
                    theseTasks.push(obj)
                })
                this.buildData(theseTasks)
            } catch (err) {
                console.error(err)
            }
        } else { 
            console.error('Tried to fetch content using undefined values ')
        }
        
    }

    //REMEMBER THAT TESTS IS A VAR LENGTH []
    buildData = (Data) => {
        var tests = []
        var hwk = []
        var incompleteTest = 0
        var incompleteHwk = 0 
        var totalTests = 0
        var totalHwk = 0
        var lateHwk = 0
        var lateTest = 0
        var studentScores = []
        var classHwkAvgs = []
        


        
        Data.forEach(data => {
            if (data.data.Test){
                tests.push(data)
            } else {
                hwk.push(data)
            }
        })
        hwk.forEach(task => {
            var studentsThatAttempted = []
            var classScores = [] 
            var classAvgHwkScore = 0 
            totalHwk = totalHwk + 1
            task.data.AssignedTo.forEach(student => {
                var obj = {id: student.Student, data: student, score: student.Score}
                console.log('obj', obj)
                if (studentScores.length == 0){
                    if (student.CompletionDate == 'N/A'){
                        incompleteHwk = incompleteHwk + 1
                        obj = {id: student.Student, data: student, score: 0}
                    } else 
                    if (new Date(student.CompletionDate).getTime() > new Date().getTime()){
                        lateHwk = lateHwk + 1
                        obj = {id: student.Student, data: student, score: 0}
                    }
                    studentScores.push([obj])
                } else
                if (!studentScores.forEach(stu => { return stu.id == student.Student})) {
                    if (student.CompletionDate == 'N/A'){
                        incompleteHwk = incompleteHwk + 1
                        obj = {id: student.Student, data: student, score: 0}
                    } else 
                    if (new Date(student.CompletionDate).getTime() > new Date().getTime()){
                        lateHwk = lateHwk + 1
                        obj = {id: student.Student, data: student, score: 0}
                    }
                    studentScores.push([obj])
                } else {
                    console.log('I think this student already has a score in the arr')
                    var index = studentScores.forEach(stu => { if (stu[0].id == student.Student){
                        return studentScores.indexOf(stu)
                    }})
                    console.log(index)
                    if (student.CompletionDate == 'N/A'){
                        incompleteHwk = incompleteHwk + 1
                        obj = {id: student.Student, data: student, score: 0}
                    } else 
                    if (new Date(student.CompletionDate).getTime() > new Date().getTime()){
                        lateHwk = lateHwk + 1
                        obj = {id: student.Student, data: student, score: 0}
                    }
                    studentScores[index].push(obj)
                }

                classAvgHwkScore = classAvgHwkScore + obj.score
            })
            var lengthForAvg = (lateHwk + incompleteHwk)
            var lengthForAvg = (task.data.AssignedTo.length - lengthForAvg)
            classHwkAvgs.push((Math.round(classAvgHwkScore/lengthForAvg)))
        })

        this.setState({
            tests: tests
        })
        // console.log('hwk', hwk, 'tests', tests, 'student scores', studentScores, 'class avgs', classHwkAvgs)
        // console.log('total', totalHwk, 'late', lateHwk, 'incomplete', incompleteHwk)
        this.buildGraph(hwk, studentScores, classHwkAvgs)
        // this.studentBreakdown(tests)
        this.testTable(tests)
        this.perTest(tests)

    }

    buildGraph = (labels, classSet, avgs) => {
        var colourArr = ['100,149,237,1', '255,127,80,1', '138,43,226,1', '220,20,60,1','0,0,128,1','160,82,45,1','221,160,221,1']
        var studentData = []
        var datasets = []
        var arr = this.state.graphData

        classSet.forEach( async student => { 
            var scoreArr = []
            var index = classSet.indexOf(student)
            var colour = ''
            var name = this.getName(student[0].id).then(name => {return name})
            // console.log(name)
            student.forEach( assignment => {
                scoreArr.push(assignment.score)
            })
            if (index > colourArr.length){
                index = index - colourArr.length
            }
            colour = colourArr[index]
            var obj = {
                label: name,
                fill: false,
                lineTension: 0.1,
                backgroundColor: colourArr[index],
                borderColor: colourArr[index],
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: colourArr[index],
                pointBackgroundColor: colourArr[index],
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: colourArr[index],
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 3,
                pointHitRadius: 10,
                data: scoreArr
            }
            // datasets.push(obj)
        })

        // window.alert(avgs)

        var avgData = {
            label: 'Average Homework performance',
            fill: false,
            lineTension: 0.1,
            backgroundColor: colourArr[3],
            borderColor: colourArr[3],
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: colourArr[3],
            pointBackgroundColor: colourArr[3],
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: colourArr[3],
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 3,
            pointHitRadius: 10,
            data: avgs
        }

        datasets.push(avgData)
        var labelArr = []
        labels.forEach(label => {labelArr.push(label.id)})
        
        var finalObj = {
            labels: labelArr,
            datasets: datasets
        }
        // arr.push(finalObj)
        // console.log(datasets, labelArr, finalObj, arr, [])
        this.setState({
            graphData: finalObj
        })
    }


    getName = async (id) => {
        var output
        var ref = await db.collection('Users').where('UID', '==', id).get()
        ref.forEach(doc => {
            output = doc.data().displayName
        })
        return output
    }

    perTest = (rawData) => { 
        // console.log(rawData)
        var output = []
        var finalIncomplete = []
        var finalLate = []
        
        //-----------------------------------//
        rawData.forEach( async test => {
            totalAssigned = totalAssigned + 1 
            //-------DECLARATIONS---------//
            var avg = 0
            var scoreTotal = 0
            var totalAssigned = 0
            var totalCompleted = 0
            var late = []
            var incomplete = []
            var dueStatus = false
            var dueDate = test.data.Deadline
            var section  = test.data.Section
            //---------IS IT DUE YET------------//
            if (new Date(test.data.Deadline).getTime() <= new Date().getTime()){
                dueStatus = true
            }
            //---------PER STUDENT GET AVG AND GET LATE/INCOMPLETE-----------//
            test.data.AssignedTo.forEach( student => {
                totalAssigned = totalAssigned + 1
                        if (student.CompletionDate == 'N/A' || new Date(dueDate).getTime() < new Date(student.CompletionDate).getTime()){
                            if (dueStatus){
                                // console.log(name[0])
                                late.push({name: student.displayName, score: student.Score})
                            } else {
                                // console.log(name[0])
                                incomplete.push(student.displayName)
                            }
                        } else {
                            // console.log('HERE', student, student.Score)
                            totalCompleted = totalCompleted + 1
                            scoreTotal = scoreTotal + student.Score
                        }
                return
            })

            if (scoreTotal > 0) {
                avg = Math.round(scoreTotal/totalCompleted)
            } else {
                avg = avg
            }
            // console.log('avg', avg)
            
            var obj = {
                title : test.id,
                section : section,
                dueDate : dueDate,
                due : new String(dueStatus),
                totalAssigned : totalAssigned,
                totalCompleted: totalCompleted,
                avgScore: avg,

            }
            output.push(obj)
            finalLate.push(late)
            finalIncomplete.push(incomplete)
        })
        
        // console.log(output)
        this.setState({
            late: finalLate,
            incomplete: finalIncomplete,
            perTest: output
        })
    }


    //-------------------------------- CREATING TABLES-------------------------------------//



    getStudents = async (level, year, ability) => { 
        var output = [] 
        var studentList = await db.collection('Users').where('CurrentLevel', '==', level).where('CurrentYear', '==', year).where('ability', '==', ability).get()
        studentList.forEach( stu => {
            output.push(stu.data().UID)
        })
        return output
    }

    testTable = async (rawData) => { 
        console.log(rawData)
        var testArr = []
        var studentArr = []
        var studentsID = await this.getStudents(this.state.viewLevel, this.state.viewYear, this.state.viewAbility)
        var outputArr = []
        var tagArr = []
        var tagTotals = []

        // rawData.forEach(test => {
        //     testArr.push(test.id)
        //     test.data.AssignedTo.forEach( student => {
        //         var history = false
        //         var dictIndex = null
        //         if (tagArr.length > 0 ){
        //             tagArr.forEach(dict => {
        //                 if (dict.owner == student.Student) {
        //                     dictIndex = tagArr.indexOf(dict)
        //                 }
        //             })
        //             if (dictIndex == null) {
        //                 tagArr.push({owner: student.Student, arr: []})
        //                 tagTotals.push({owner: student.Student, arr: []})
        //                 dictIndex = tagArr.length -1
        //             }
        //         } else {
        //             tagArr.push({owner: student.Student, arr: []})
        //             tagTotals.push({owner: student.Student, arr: []})
        //             dictIndex = tagArr.length -1
        //         }
        //         var name = student.displayName
        //         var totalMarksAvailable = 0 
        //         if (student.CompletionDate != 'N/A'){
        //              student.perQuestion.forEach(Q => {
        //                 Q.tags.forEach(tag => { 
        //                     const result = Q.result
        //                     var marks = 0
        //                     if (result){
        //                         marks = parseInt(Q.weight)
        //                     }
        //                     if(!tagArr[dictIndex].arr.includes(tag)){ 
        //                         tagArr[dictIndex].arr.push(tag) 
        //                         tagTotals[dictIndex].arr.push({tag: tag, tagTotal: parseInt(Q.weight), score: marks })
                                
        //                     } else {
        //                         const index = tagArr[dictIndex].arr.indexOf(tag)
        //                         console.log(tagTotals, index, tagArr, tagArr[dictIndex].arr.includes(tag), student)
        //                         tagTotals[dictIndex].arr[index].tagTotal = tagTotals[dictIndex].arr[index].tagTotal + parseInt(Q.weight)
                                
        //                         if (result){
        //                             tagTotals[dictIndex].arr[index].score = tagTotals[dictIndex].arr[index].score + parseInt(Q.weight)
        //                         }
        //                     }
        //                 })
        //                 totalMarksAvailable = parseInt(totalMarksAvailable) + parseInt(Q.weight)
        //             })
        //         } 
        //        console.log(tagTotals, student.Student, tagArr)
        //         if (!studentsID.includes(student.Student)){
        //             studentsID.push(student.Student)
        //             var placeholders = []
        //             const tIndex = rawData.indexOf(test)
        //             for (var i = 0; i < tIndex; i++){
        //                 placeholders.push([0])
        //             }
        //             placeholders.push([student.Score])
        //             studentArr.push({
        //                 id: student.Student,
        //                 data:{
        //                     name: name,
        //                     avgScore: 0,
        //                     scoreArr: [placeholders[0]],
        //                     tasksSat: 1,
        //                     tags: tagTotals[dictIndex].arr,
        //                     totalMarksAvailable: totalMarksAvailable

        //                 }
                        
        //             })
        //             placeholders = placeholders.slice(1, placeholders.length)
        //             placeholders.forEach(score => { studentArr[studentArr.length-1].data.scoreArr.push(score)})

        //         } else {
        //             const index = studentsID.indexOf(student.Student)
        //             if (studentArr[index].data.scoreArr) {
        //                 var placeholders = []
        //                 const tIndex = rawData.indexOf(test)
        //                 const len = studentArr[index].data.scoreArr.length
        //                 for (var i = 0; i < (tIndex - len); i++){
        //                     placeholders.push([0])
        //                 }
        //                 placeholders.push([student.Score])
        //                 studentArr[index].data.tags.push(tagTotals[dictIndex].arr)
        //                 placeholders.forEach(score => { studentArr[index].data.scoreArr.push(score)})
        //                 studentArr[index].data.totalMarksAvailable =  studentArr[index].data.totalMarksAvailable + totalMarksAvailable
        //                 studentArr[index].data.tasksSat = studentArr[index].data.tasksSat + 1
        //             } else {
        //                 studentArr[index].data.tags = [0]
        //                 studentArr[index].data.scoreArr  = [student.Score]
        //                 studentArr[index].data.totalMarksAvailable =  totalMarksAvailable
        //             }
        //         }
        //     })
        // })

        studentsID.forEach( child => {
            var name = this.getName(child).then(function(){console.log('NAME2', name)})
            var myPerformance = []
            var tagNames = [] 
            var tagData = [] 
            var scores = [] 
            rawData.forEach( test => { 
                test.data.AssignedTo.forEach( student => { 
                    if (student.Student == child){
                        myPerformance.push({performance: student, title: test.id, class: test.data})
                    }
                })
            })
            myPerformance.forEach( task => {
                console.log('TTABLE - TEST NAME', task.title, rawData[myPerformance.indexOf(task)].id, rawData[myPerformance.indexOf(task)], rawData, child, task)
                if (task.title != rawData[myPerformance.indexOf(task)].id){
                    scores.push('-')
                }
                if (task.performance.CompletionDate != 'N/A' && new Date(task.performance.CompletionDate).valueOf() < new Date(task.class.Deadline).valueOf() ){
                    scores.push(task.performance.Score)
                    if (task.performance.perQuestion){ 
                        // console.log('TTable')
                        task.performance.perQuestion.forEach( question => { 
                            if (question.tags.length > 0){
                                question.tags.forEach( tag => { 
                                    const index = tagNames.indexOf(tag)
                                    console.log('TTag', tag, tagData, index)
                                    if (index != -1){
                                        // We already have it so just add the value to the right index of tagData
                                        tagData[index].total = tagData[index].total + parseInt(question.weight)
                                        if (question.result){
                                            tagData[index].rT = tagData[index].rT + parseInt(question.weight)
                                        }
                                    } else {
                                        // console.log('TTable', question)
                                        // We dont have it yet so we should add it to the tagNames arr and make a spot for it in tagData
                                        tagNames.push(tag)
                                        if (question.result) {
                                            tagData.push({ name: tag, rT: parseInt(question.weight), total: parseInt(question.weight) })
                                        } else {
                                            tagData.push({ name: tag, rT: 0, total: parseInt(question.weight) })
                                        } 
                                    }
                                })
                            }
                        })
                    }
                } else if (scores.length < myPerformance.indexOf(task) + 1){
                    scores.push('-')
                }
                
            })
            if (scores.length < rawData.length){
                const indexCount = rawData.length - scores.length
                for (var i = 0; i < indexCount; i++){
                    scores.push('-')
                }
            }
            console.log('TTable', tagData, tagNames, scores, this.state.tests, myPerformance)

            if (myPerformance.length > 0 && myPerformance[0].performance && myPerformance[0].performance.displayName){
                //do the regular 
                studentArr.push({id: child, name: myPerformance[0].performance.displayName, tests: myPerformance, scoreArr: scores, tags: tagData})
            } else {
                console.log('NAME', name)
                studentArr.push({id: child, name: name, tests: myPerformance, scoreArr: scores, tags: tagData})
                //push with some placeholdername for it
                
            }
            

            
        })

        console.log('TTABLE', studentsID, studentArr)

        studentArr.forEach( async student => {
            var totalMarks = 0
            var avgPercent = 0 
            var topTags = []
            var worstTags = []
            var scoreLength = student.scoreArr.length
            console.log(student)

            student.scoreArr.forEach(score => { if( score != '-'){totalMarks = totalMarks + score} else { scoreLength = scoreLength - 1}})
            if (totalMarks != 0) {
                avgPercent = Math.round(totalMarks/scoreLength)
            } else {
                avgPercent = 0
            }

            

            if (student.tags.length > 0){
                console.log(student.tags, 'TTAGS, SORT RAW')
                student.tags.forEach( tag => { 
                    return tag.value = tag.rT/tag.total
                })
                
                var tags = JSON.parse(JSON.stringify(student.tags))
                tags.sort((a, b) => { return a.value - b.value })
                student.tags.sort((a, b) => { return b.value - a.value })


                console.log('TTAGS COMPARE', tags, student.tags)
                topTags = student.tags;
                worstTags = tags
            }

            console.log(student.tags, 'TTAGS, SORT', topTags, worstTags)
            
            if (student.tags.length > 3){
                    topTags = topTags.slice(0,3)
                worstTags = worstTags.slice(0,3)
            }
            
            
            
            outputArr.push({name: student.name, avgPercent: avgPercent, scoreArr: student.scoreArr, topTags: topTags, worstTags: worstTags, tasksSat: student.tests.length})
        })
        console.log('TTable', outputArr)
        this.setState({
            testDataArr: outputArr,
            tests: rawData
        })
    }

    //---------------Turn data into data for table--------------------//
    createData(name, avgMark, avgPercent, scoreArr, topTags, worstTags, tasksSat) {
        id += 1;
        var obj = {name, avgMark, avgPercent, topTags, worstTags, tasksSat}
        var toPush=[]
        scoreArr.forEach(score => {
            obj['z' + Object.keys(obj).length] = score
            // console.log('HEREH', scoreArr,obj)
            toPush.push(score)
        })
        this.state.cells.push(toPush)
        return obj; 
    }

    //---------------Create the rows of the table--------------//
    rows = (arr) => {
        const output = []
        console.log(arr);
        arr.map(record => {
            output.push(
                this.createData(record.name, record.avgMark, record.avgPercent, record.scoreArr, record.topTags, record.worstTags, record.tasksSat)
            )
        })
        return output
    }

    //---------------Search our table data---------------//
    searchArr = (arr, searchTerm ) => {
        console.log(searchTerm, arr)
        searchTerm = searchTerm.toLowerCase()
        var output = [];
        arr.forEach(e => {
            try {
                //the regular
                if (e.name) {
                    if (e.name.toLowerCase().search(searchTerm) != -1) {
                        output.push(e)
                    }
                } else {
                    output.push(e)
                }
            } catch (err){ 
                console.error(err.message);
            }
        })
        return output
    }

    makeTableData = (arr) => {
        console.log(arr, this.state.testDataArr)
        var output = this.searchArr(this.rows(arr), this.state.searchTerm)
        function something(){return this.setState({...this.state, tableData : output})}
        something
        return output
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };
    //------------------------------------------------------------------------------------------//


    allDefined = (level, subj, yr, ability) => {
        if (level == undefined || level.length == 0){
            this.setState({
                levelError: true,
                viewSubject: '',
                viewAbility: '',
                viewYear: ''
            })
            return false
        } else
        if (!this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(level)] || this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(level)].length == 0 || subj.length == 0 || !this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(level)].includes(subj)){
            this.setState({
                subjectError: true,
                viewYear: '',
                viewAbility: ''
            })
            return false
        } else
        if (!this.state.yearsToSearch[this.state.levelsToSearch.indexOf(level)][this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(level)].indexOf(subj)] || yr.length == 0){
            this.setState({ 
                yearError: true,
                viewAbility: ''
            })
            return false
        } else
        if (ability.length <= 0){
            this.setState({
                abilityError: true,
            })
            return false
        } else {
            return true
        }
    }
    render(){
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                
                {this.state.yearsToSearch.length > 0 && this.state.subjectsToSearch.length > 0 ?
                <Grid container
                    spacing={24}
                    direction='row'
                    justify='space-evenly'
                    alignContent='center'
                >
                    <Grid item xs={4} className={classes.grid}>
                        <Paper className={classes.paper} elevation={1}>
                            <Typography variant='headline'>
                                Specify dataset 
                            </Typography>
                            <Divider/>
                            <br/>
                            <TextField
                                id='Level'
                                value={this.state.viewLevel}
                                onChange={this.handleChange('viewLevel')}
                                error={this.state.levelError}
                                margin='normal'
                                helperText='Please select a level to view'
                                select
                            >
                                {this.state.levelsToSearch.map(level => (
                                    <MenuItem key={this.state.levelsToSearch.indexOf(level)} value={level}>
                                        {level}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <br/>
                            {this.state.viewLevel.length > 0 && this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)].length > 0 ?
                                <div>
                                     <TextField
                                        id='Subject'
                                        value={this.state.viewSubject}
                                        onChange={this.handleChange('viewSubject')}
                                        error={this.state.subjectError}
                                        margin='normal'
                                        helperText='Please select a subject to view'
                                        select
                                    >
                                        {this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)].map(subject => (
                                            <MenuItem key={this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)].indexOf(subject)} value={subject}>
                                                {subject}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <br/>
                                    {this.state.viewSubject.length > 0 && this.state.yearsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)][this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)].indexOf(this.state.viewSubject)] ?
                                        <div>
                                            <TextField
                                                id='Year'
                                                value={this.state.viewYear}
                                                onChange={this.handleChange('viewYear')}
                                                error={this.state.yearError}
                                                margin='normal'
                                                helperText='Please select a year to view'
                                                select
                                            >
                                                {this.state.yearsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)][this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)].indexOf(this.state.viewSubject)].map(year => (
                                                    <MenuItem key={this.state.yearsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)][this.state.subjectsToSearch[this.state.levelsToSearch.indexOf(this.state.viewLevel)].indexOf(this.state.viewSubject)].indexOf(year)} value={year}>
                                                        {year}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                            <br/>
                                            <TextField
                                                id='Level'
                                                value={this.state.viewAbility}
                                                onChange={this.handleChange('viewAbility')}
                                                error={this.state.abilityError}
                                                margin='normal'
                                                helperText='Please select an ability level to view'
                                                select
                                            >
                                                {this.state.abilitiesToSearch.map(ability => (
                                                    <MenuItem key={this.state.abilitiesToSearch.indexOf(ability)} value={ability}>
                                                        {ability}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>
                                    :
                                        <div/>
                                    }
                                    
                                </div>
                            :
                                <div/>
                            }
                            <br/>
                                <Button 
                                className={classes.button} 
                                variant='raised' 
                                onClick={() => { this.contentFetch(this.state.viewLevel, this.state.viewSubject, this.state.viewYear, this.state.viewAbility)}}
                            >
                                View data
                            </Button>
                        </Paper>
                    </Grid>
                     <Grid item xs={8}>
                        <Paper className={classes.paper} elevation={1}>
                            {this.state.graphData.datasets ? 
                                <div>
                                    <Typography variant='title'>
                                        Homework performance over time
                                    </Typography>
                                    <Divider/>
                                    <br/>
                                    <Line data={this.state.graphData} />
                                </div>
                            :
                                <Typography variant='headline'>
                                    Please select some data to view
                                </Typography>
                            }
                            
                        </Paper>
                    </Grid>
                    {this.state.testDataArr.length > 0 ? 
                        <Grid item xs={12}>
                            <Paper className={classes.paper} elevation={1}>
                                <div>
                                    <Typography variant='title'>
                                        Per Student Test breakdown
                                    </Typography>
                                    <Divider/>
                                    <br/>
                                    <TextField className={classes.TextField}
                                        onChange={this.handleChange('searchTerm')}
                                        value={this.state.searchTerm}
                                        helperText='Search for Accounts via dislay name'
                                    />
                                    <br/>
                                    <br/>
                                    <Table className={classes.table}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>User</TableCell>
                                                <TableCell>Avg % Score</TableCell>
                                                <TableCell>Strongest Areas</TableCell>
                                                <TableCell>Areas to Develop</TableCell>
                                                <TableCell>No. Tasks Set</TableCell>
                                                {this.state.tests.map( test => { return <TableCell>{test.id}</TableCell>})}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.makeTableData(this.state.testDataArr)
                                                .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                                .map(row => {
                                                return (
                                                    <TableRow 
                                                        key={row.id}
                                                        hover
                                                        tabIndex={-1}>
                                                        { this.state.testDataArr[0].name ? 
                                                            <TableCell component="th" scope="row">{row.name}</TableCell>
                                                        :
                                                            <TableCell component="th" scope="row">fetching...</TableCell>
                                                        }
                                                        <TableCell>{row.avgPercent + '%'}</TableCell>
                                                        <TableCell>{row.topTags.map(tag => { if (tag != undefined){return (tag.name + ', ')}})}</TableCell>
                                                        <TableCell>{row.worstTags.map(tag => { return (tag.name + ', ')})}</TableCell>
                                                        <TableCell>{row.tasksSat}</TableCell>
                                                        
                                                        {Object.keys(row).slice(Object.keys(row).length - this.state.tests.length, Object.keys(row).length +1 ).map(cell => {
                                                             var output
                                                            //  console.log(this.state.cells, this.state.cells[this.state.cells.length - 1])
                                                            console.log('CELL', cell)
                                                            row[cell] != '-' ?
                                                                output = <TableCell >{row[cell] + '%'}</TableCell>
                                                            :
                                                                output = <TableCell> {row[cell]}</TableCell>

                                                            return output
                                                            
                                                        })}
                                                    </TableRow>
                                                    
                                                )
                                            })}
                                        </TableBody>   
                                    </Table>
                                    <TablePagination
                                        component='div'
                                        count={this.makeTableData(this.state.testDataArr).length}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                </div>
                            </Paper>
                        </Grid>
                    :
                        <div/>
                    }
                    
                    {/* <Grid item xs={12}>
                        <Paper className={classes.paper} elevation={1}>
                            <div>
                                <Typography variant='title'>
                                    Per Student Homework breakdown
                                </Typography>
                                <Divider/>
                            </div>
                        </Paper>
                    </Grid> */}
                    <br/>
                     {/* THESE WILL BE LOADED ON THE CONDITION THAT THERE EXISTS TEST DATA */}
                    {this.state.perTest && this.state.perTest.length > 0 && this.state.late && this.state.late.length > 0 && this.state.incomplete && this.state.incomplete.length > 0 ? 
                        <div style={{width: '98%'}}>
                            <Grid container
                                spacing={24}
                                direction='row'
                                justify='space-evenly'
                                alignContent='center'
                                style={{overflowX: 'auto'}}
                            >
                                {this.state.perTest.map(test => (
                                        <Grid item xs={6}>
                                            <div>
                                            <Paper className={classes.paper} elevation={1}>
                                                <Typography variant='title'>
                                                    {'Breakdown for: ' + test.title}
                                                </Typography>
                                                <Divider/>
                                                <br/>
                                                <Typography variant='subheading'>
                                                    Section: {test.section}
                                                    <br/>
                                                    Avg Result: {test.avgScore + '%'}
                                                    <br/>
                                                    Due Date: {test.dueDate} 
                                                    <br/>
                                                    Due : {test.due} 
                                                    <br/>
                                                    Assigned to: {test.totalAssigned + ' Students'} 
                                                    <br/>
                                                    Completed by: {test.totalCompleted + ' Students'} 
                                                    <br/>
                                                    Submitted Late: {this.state.late[this.state.perTest.indexOf(test)].length + ' Students'} 
                                                    <br/>
                                                    Late Students: {this.state.late[this.state.perTest.indexOf(test)].map(stu => { return (stu.name + ', ')})} 
                                                    <br/>
                                                    Failed to complete: {this.state.incomplete[this.state.perTest.indexOf(test)].length + ' Students'} 
                                                    <br/>
                                                    Incomplete: {this.state.incomplete[this.state.perTest.indexOf(test)].map(s => { return (s + ', ')})} 
                                                    <br/>
                                                </Typography>
                                                <br/>
                                                <Divider/>
                                            </Paper>
                                            </div>
                                        </Grid>
                                ))}
                            <br/>
                            </Grid>
                        </div>
                    :
                        <Grid item xs={6}>
                            <Paper className={classes.paper} elevation={1}>
                                <Typography variant='title'>
                                    No Test Data
                                </Typography>
                                <Divider/>
                                <br/>
                                <Typography variant='subheading'>
                                  There Doesn't appear to be any test Data for this subject
                                </Typography>
                                <br/>
                                <Divider/>
                            </Paper>
                        </Grid>
                    }
                    
                    
                    {/* ---------------------------------------------------------------------- */}
                </Grid>
                 
                :
                <Grid container
                    spacing={24}
                    direction='row'
                    justify='space-evenly'
                    alignContent='center'
                >
                    <Grid item xs={12}>
                        <Paper className={classes.paper} elevation={1}>
                        {this.state.loading ? 
                                <Grid item xs={12}>
                                        <div style={{width: '100%', alignItems: 'center'}}>
                                            <CircularProgress className={classes.progress} color="inherit" />
                                        </div> 
                                        {setTimeout(() => {this.setState({loading: false})}, 3500)}
                                </Grid> 
                        :
                            <div>
                                <Typography variant='headline'>
                                    There doesn't appear to be any content on the system. Please contact an admin.
                                </Typography>
                                <Divider/>
                            </div>
                        }
                        </Paper>
                    </Grid>
                </Grid>
                }
                
            </div>
        )
    }
}
export default withStyles(styles)(adminDash);


// WEBPACK FOOTER //
// ./src/Dashboards/adminDash.jsx